"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var styles = function (theme) {
    var _a, _b;
    return (0, core_1.makeStyles)({
        mainContainer: (_a = {
                padding: theme.spacing(3, 5)
            },
            _a[theme.breakpoints.up('sm')] = {
                padding: theme.spacing(5.5)
            },
            _a),
        field: {
            width: '100%',
            marginTop: theme.spacing(2.5),
            '& .MuiOutlinedInput-input': {
                padding: theme.spacing(2)
            }
        },
        button: {
            minWidth: theme.spacing(19.5),
            minHeight: '48px',
            width: 'auto',
            '&, & .MuiButton-containedSizeLarge': {
                padding: theme.spacing(1.6875, 1.5),
                border: 'none'
            }
        },
        titleText: (_b = {
                textAlign: 'center'
            },
            _b[theme.breakpoints.down('xs')] = {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(5.5)
            },
            _b[theme.breakpoints.up('sm')] = {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(5.5)
            },
            _b)
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map